import * as yup from 'yup';

export const CreateTeamSchema = yup.object({
    name: yup
        .string()
        .required('Errors.error_required')
        .min(2, 'Errors.error_min_2')
        .max(40, 'Errors.error_max_40'),
});